import { render, staticRenderFns } from "./TableSupplyManagerReady.vue?vue&type=template&id=89b458e0&"
import script from "./TableSupplyManagerReady.vue?vue&type=script&lang=ts&"
export * from "./TableSupplyManagerReady.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports